<template>
    <div class="feedback">
        <div class="feedback_mian" :class="{fold: !show}">
            <div class="wrapper">
                <div class="item" @mouseover="QRcode = true" @mouseout="QRcode = false" v-stat="$stats.personalCenter.openWechat">
                    <img src="//i.thsi.cn/images/private_home/QRCode_icon.png" alt="">
                    <span>官方微信</span>
                </div>
            </div>
            <div class="QRcode" v-show="QRcode">
                <img src="//i.thsi.cn/images/private_home/smzj_QR_code.png" alt="">
            </div>
            <!-- <i class="close" @click="show = false">+</i> -->
            <!-- <div class="feedback_totop" @click="scrollToTop()"></div> -->
            <div class="handle" @click="show = !show">
                <i class="arrow_icon"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            QRcode: false,
            describe: '',
            tel: '',
            show: true
        }
    },
    methods: {
        scrollToTop () {
            let timer = null
            cancelAnimationFrame(timer)
            let scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop
            timer = requestAnimationFrame(function fn () {
                if (scrollTop > 0) {
                    scrollTop -= 150
                    document.body.scrollTop = document.documentElement.scrollTop = scrollTop
                    timer = requestAnimationFrame(fn)
                } else {
                    cancelAnimationFrame(timer)
                }
            })
        }
    },
    watch: {},
    mounted () {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.feedback {
    position: fixed;
    right: 27px;
    bottom: 50%;
    z-index: 998;
    box-sizing: border-box;
    &.moblie {
        right: 0.75rem;
    }
    .feedback_mian {
        .wrapper {
            overflow: hidden;
            .item {
                width: 86px;
                height: 86px;
                border-radius: 4px;
                text-align: center;
                background: url('//i.thsi.cn/images/private_home/consultation_item_img_1.png');
                margin-bottom: 10px;
                transition: transform 0.2s;
                cursor: pointer;
                padding-top: 10px;
                box-sizing: border-box;
                span {
                    display: inline-block;
                    font-size: 14px;
                    color: #FFFFFF;
                }
                &:hover {
                    background: url('//i.thsi.cn/images/private_home/consultation_item_img_2.png');
                }
                &:active {
                    background: url('//i.thsi.cn/images/private_home/consultation_item_img_3.png');
                }
            }
        }
        &.fold {
            .wrapper {
                pointer-events: none;
                .item {
                    transform: translateX(100%);
                }
            }
            .handle {
                // transform: translateX(100%);
                left: 100%;
                transform: translateX(-100%);
                .arrow_icon {
                    transform: rotateZ(180deg);
                }
            }
        }
        .feedback_txt {
            width: 44px;
            height: 117px;
            background: #fff;
            border: 1px solid #e1e8f0;
            box-sizing: border-box;
            margin-bottom: 24px;
            position: relative;
            & > p {
                &:first-child {
                    width: 20px;
                    height: 20px;
                    background: url(//i.thsi.cn/images/private_home/feedback_txt.png) no-repeat;
                    margin: 8px 11px;
                }
                box-sizing: border-box;
                color: #4c4c4c;
                font-size: 16px;
                writing-mode: tb;
                letter-spacing: 0.1em;
                padding: 0 14px;
                line-height: 16px;
            }
            .feedback_QRcode {
                position: absolute;
                width: 153px;
                height: 180px;
                top: -1px;
                left: -158px;
                &::before {
                    display: block;
                    content: '';
                    width: 0;
                    height: 0;
                    border-top: 4px solid transparent;
                    border-bottom: 4px solid transparent;
                    border-left: 9px solid #e1e8f0;
                    position: absolute;
                    top: 20px;
                    right: -3px;
                }
                &::after {
                    display: block;
                    content: '';
                    width: 0;
                    height: 0;
                    border-top: 4px solid transparent;
                    border-bottom: 4px solid transparent;
                    border-left: 9px solid #fff;
                    position: absolute;
                    top: 20px;
                    right: 0px;
                }
                & > * {
                    padding: 0 16px;
                    width: 100%;
                    background: #fff;
                    display: block;
                }
                .img {
                    width: 114px;
                    height: 114px;
                    padding: 15px 16px 8px;
                    border: 1px solid #e1e8f0;
                    border-bottom: none;
                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }
                p {
                    width: 114px;
                    text-align: center;
                    font-size: 14px;
                    line-height: 14px;
                    color: #4c4c4c;
                    padding-bottom: 6px;
                    border: 1px solid #e1e8f0;
                    border-bottom: none;
                    border-top: none;
                    &:last-child {
                        border-bottom: 1px solid #e1e8f0;
                        width: 130px;
                        padding: 0 8px 12px;
                    }
                }
            }
        }
        .close {
            display: inline-block;
            width: 20px;
            height: 20px;
            // z-index: 100;
            // background: no-repeat url('~@/assets/img/small_icon.png') 0px -65px white;
            position: absolute;
            top: -10px;
            right: -10px;
            border-radius: 13px;
            background: #1664e1;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            color: white;
            transform: rotateZ(45deg);
        }
        .handle {
            display: inline-block;
            width: 30px;
            height: 40px;
            background: #4a9af6;
            border-radius: 3px;
            transition: all 0.2s;
            text-align: center;
            position: relative;
            left: 0;
            cursor: pointer;
            .arrow_icon {
                display: inline-block;
                border-top: 12px solid transparent;
                border-bottom: 12px solid transparent;
                border-left: 10px solid white;
                position: relative;
                top: 8px;
                left: 0;
                &::after {
                    content: '';
                    display: inline-block;
                    position: absolute;
                    top: -10px;
                    left: -10px;
                    border-top: 10px solid transparent;
                    border-bottom: 10px solid transparent;
                    border-left: 8px solid #4a9af6;
                }
            }
        }
        .QRcode {
            position: absolute;
            width: 143px;
            height: 200px;
            // background: white;
            left: -153px;
            top: 96px;
        }
        .feedback_totop {
            width: 44px;
            height: 44px;
            background: url(//i.thsi.cn/images/private_home/feedback_top.png) no-repeat;
        }
        // 移动端样式
        .feedback_apply, .feedback_con {
            width: 2.7rem;
            height: 2.7rem;
            border-radius: 50%;
            display: block;
            p {
                font-size: 0.75rem;
                padding: 0.25rem;
                text-align: center;
            }
        }
        .feedback_apply {
            background: #3f5894;
            margin-bottom: 0.875rem;
            p {
                color: #fff;
            }
        }
        .feedback_con {
            background: #fff;
            box-shadow: 0 0 10px rgba(0,0,0,0.1);
            p {
                color: #898989;
            }
        }
    }
    .consultation {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        cursor: default;
        .consultation_main {
            width: 540px;
            height: 307px;
            position: absolute;
            bottom: 50%;
            left: 50%;
            transform: translate(-50%, 0);
            box-sizing: border-box;
            padding: 26px 30px 0 177px;
            background: no-repeat url('//i.thsi.cn/images/private_home/consultation_img.png') left center white;
            box-shadow: 0 0 10px rgba(0,0,0,0.1);
            h2 {
                font-size: 18px;
                color: #666666;
                font-weight: 600;
            }
            p {
                font-size: 14px;
                color: #666666;
                margin: 15px 0 5px 0;
            }
            textarea {
                box-sizing: border-box;
                width: 100%;
                height: 70px;
                background: rgba(240, 244, 247, 1);
                border: 1px solid rgba(237, 241, 242, 1);
                padding: 10px;
                resize: none;
                font-size: 12px;
                color: #B3B3B3;
            }
            input {
                box-sizing: border-box;
                width: 100%;
                height: 28px;
                background: rgba(240, 244, 247, 1);
                border: 1px solid rgba(237, 241, 242, 1);
                padding: 0 10px;
                font-size: 12px;
                color: #B3B3B3;
            }
            .action {
                margin-top: 18px;
                text-align: center;
                button {
                    width: 104px;
                    height: 30px;
                    line-height: 30px;
                    border: none;
                    border-radius: 15px;
                    background: linear-gradient(154deg, #288bfc 0%, #1664e1 100%);
                    font-size: 14px;
                    color: #fff;
                    outline: none;
                    cursor: pointer;
                }
            }
            i {
                display: inline-block;
                width: 16px;
                height: 16px;
                position: absolute;
                top: 12px;
                right: 12px;
                background: url(//i.thsi.cn/images/private_home/close_icon_1.png);
                cursor: pointer;
                &:hover {
                    background: url(//i.thsi.cn/images/private_home/close_icon_2.png);
                }
                &:active {
                    background: url(//i.thsi.cn/images/private_home/close_icon_3.png);
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/asideFeedback.vue